export default __webpack_public_path__ + "static/media/Skey-Network-Wave.111cce24.png";